import { apiDev } from '@/scripts/axios';
import { catchError } from '@/scripts/utils/store-dependent';

/* R */
const getGameConnectionsInfo = id =>
  apiDev
    .get(`games/${id}/gameConnections`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getAllConnections = () =>
  apiDev
    .get(`gameConnections`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getConnectionInfo = id =>
  apiDev
    .post(`gameConnections/${id}`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

/* C */
const requestConnectionCreation = params =>
  apiDev
    .post(`gameConnections/create`, params)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const confirmConnectionCreation = redirectURL =>
  apiDev
    .post(`gameConnections/confirm`, { redirectURL })
    .then(({ data: { response } }) => response.id)
    .catch(catchError);

/* D */
const deleteConnection = id =>
  apiDev
    .post(`gameConnections/${id}/disconnect`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

/*  */
export {
  getGameConnectionsInfo,
  getConnectionInfo,
  requestConnectionCreation,
  confirmConnectionCreation,
  deleteConnection,
  getAllConnections,
};
